import React, { useEffect, useState, useRef, useMemo, useContext } from "react";
import SweetAlert from "sweetalert2";
import api from "../../../services/api";
import TableGrid from "../../../components/TableGrid";
import CardFooter from "../../../components/CardFooter";
import CustomModal from "../../../components/Modal";
import Button from "../../../components/Button";
import { toast } from "react-toastify";
import { Context } from './Context'
import RepresentanteNovo from './RepresentanteNovo'
import {
  formatCnpjCpf
} from "../../../util/rotinas";

export default function Representantes(props) {

  const { materaId } = props

  const [loading, setLoading] = useState(false);
  const [listRepresentantesFiltrado, setListRepresentantesFiltrado] = useState(undefined);
  const { isOpenModal, toggleCreate, toggleEdit, handleClose, setRepresentanteEdit } = useContext(Context)
  const modalRef = useRef(null);

  //Acessos
  const [btnNovoRepresentante, setBtnNovoRepresentante] = useState(true);
  const [btnEditarCliente, setBtnEditarCliente] = useState(true);
  const [btnExcluirCliente, setBtnExcluirCliente] = useState(true);

  useEffect(() => {
    if (listRepresentantesFiltrado === undefined) {
      setListRepresentantesFiltrado(props.representantes)
    }
  }, [listRepresentantesFiltrado, props.representantes])

  const deleteRepresentative = function (obj) {
    SweetAlert.fire({
      title: "Confirma exclusão do Representante ?",
      text: `${obj?.name}`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Sim",
      cancelButtonText: "Não",
    }).then((result) => {
      if (result.isConfirmed) {
        api.delete(`/representative/${obj.id}`).then(() => {
          toast.success(`Registro excluído com sucesso.`, {
            position: "bottom-center",
            autoClose: true,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: false,
            draggable: true,
            progress: 0,
          });
          window.location.reload();
        }).catch((err) => {
          console.log(err);
        });
      }
    });
  };

  function editRepresentante(row) {
    toggleEdit()
    let temp = row
    temp['date_birth'] = temp['date_birth'].split('T')[0]
    setRepresentanteEdit(temp)
  }

  const columns = useMemo(() => [
    {
      name: "CPF",
      selector: "cpf",
      sortable: true,
      width: "150px",
      cell: (row) => formatCnpjCpf(row.cpf),
    },
    {
      name: "Nome",
      selector: "name",
      sortable: true,
      cell: (row) => row.name,
    },
    {
      name: "Email",
      selector: "email",
      sortable: true,
      cell: (row) => row.email,
    },
    {
      width: "70px",
      cell: (row) => (
        <div className="btn-group btn-group-xs pull-right">

          {btnEditarCliente ? (
            <>
              <button
                className="btn btn-default btn-xs"
                onClick={() => editRepresentante(row)}
              >
                <i className="fa fa-fw fa-pencil"></i>
              </button>
            </>
          ) : null}
          {materaId === null && btnExcluirCliente ? (
            <>
              <button
                onClick={() => deleteRepresentative(row)}
                className="btn btn-danger btn-xs"
              >
                <i className="fa fa-fw fa-trash-o"></i>
              </button>
            </>
          ) : null}
        </div>
      ),
      ignoreRowClick: true,
      allowOverflow: true,
      button: true,
    },
  ]);


  return (
    <>
      {props.representantes.length > 0 ?
        <div style={{ display: "flex", flexDirection: "column", gap: "20px" }} >
          <TableGrid
            columns={columns}
            data={listRepresentantesFiltrado}
            paginationPerPage={10}
            pagination={false}
            loading={loading}
          />
          {btnNovoRepresentante ? (
            <CardFooter loading={loading}>
              <Button
                type="button"
                title="Cadastrar Representante"
                onClick={() => toggleCreate()}
              />
            </CardFooter>
          ) : null}
        </div>
        :
        <CardFooter loading={loading}>
          <Button
            type="button"
            title="Cadastrar Representante"
            onClick={() => toggleCreate()}
          />
        </CardFooter>
      }

      <CustomModal
        id="modalTeste"
        open={isOpenModal}
        close={handleClose}
        modalRef={modalRef}
      >
        <RepresentanteNovo />
      </CustomModal>

    </>
  )
}